var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeGoldWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_1572_76826)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3027 20.9662L31.1668 17.3071C31.0652 17.1331 30.8982 17.0063 30.703 16.956C30.5088 16.9077 30.3006 16.9359 30.1275 17.0395L23.5981 20.9572L33.3027 20.9662Z",
    fill: "#1D1B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.946 21.9632C18.3926 21.9632 17.9399 21.5105 17.9399 20.9572C17.9399 20.4038 18.3926 19.9511 18.946 19.9511H22.3364L25.6967 17.9389H18.946C17.457 17.9389 16.2195 19.0255 15.978 20.4541C15.9579 20.5346 15.9277 20.6151 15.9277 20.7056V36.0483C15.9277 37.7083 17.2859 39.0665 18.946 39.0665H36.0492C37.1559 39.0665 38.0614 38.1611 38.0614 37.0544V35.0422H35.5462C33.0511 35.0422 31.0189 33.0099 31.0189 30.5149C31.0189 28.0198 33.0511 25.9875 35.5462 25.9875H38.0614V23.9754C38.0614 22.8687 37.1559 21.9632 36.0492 21.9632H18.946ZM35.0432 19.9511C35.0432 18.9349 34.2886 18.0898 33.3027 17.9591L35.0432 20.9572V19.9511Z",
    fill: "#1D1B18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.319 27.4967H35.5462C33.8822 27.4967 32.528 28.8508 32.528 30.5149C32.528 32.1789 33.8822 33.5331 35.5462 33.5331H39.319C39.7355 33.5331 40.0736 33.1951 40.0736 32.7786V28.2512C40.0736 27.8347 39.7355 27.4967 39.319 27.4967ZM35.5462 31.521C34.9909 31.521 34.5402 31.0702 34.5402 30.5149C34.5402 29.9595 34.9909 29.5088 35.5462 29.5088C36.1016 29.5088 36.5523 29.9595 36.5523 30.5149C36.5523 31.0702 36.1016 31.521 35.5462 31.521Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_76826",
    x1: 0,
    y1: 28.002,
    x2: 56,
    y2: 28.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGoldWallet);
export default __webpack_public_path__ + "static/media/Home_Gold_Wallet.900104e54236b3a70837156b1544644a.svg";
export { ForwardRef as ReactComponent };